<template>
  <b-row>
    <b-col>
      <b-row
        class="mb-1"
        align-h="center"
      >
        <b-col cols="auto">
          <div style="display:flex;">
            <h4>Detalhamento das configurações de cobrança</h4>
            <div style="padding-left: 0.4rem">
              <i
                v-b-tooltip.hover
                :title="descricao"
                style="font-size: 0.85rem;"
                class="question-icon"
              >
                <font-awesome-icon
                  :icon="faQuestionCircle"
                />
              </i>
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-table
            v-if="carregado"
            :fields="colunas"
            :items="dados"
            :outlined="true"
            :responsive="true"
            foot-clone
            class="tabela-configuracao"
          >
            <template #head()="data">
              <span>{{ data.label }}</span>
            </template>
            <template #cell(equipe)="{ item }">
              <div class="legenda-tabela">
                <div
                  :style="`background-color:${item.color};`"
                  :class="['circle', {'opcao-branca': item.color == '#FFFFFF'}]"
                />
                <span>{{ item.nomeEquipe }}</span>
              </div>
            </template>
            <template #cell(comConfiguracao)="{ item }">
              <span>{{ item.totalConfiguracao }}</span>
            </template>
            <template #cell(semConfiguracao)="{ item }">
              <span>{{ item.totalSemConfiguracao }}</span>
            </template>
            <template #cell(total)="{ item }">
              <span>{{ item.total }}</span>
            </template>

            <template #foot(equipe)="">
              <span />
            </template>
            <template #foot(comConfiguracao)="">
              <span>{{ totalizadorComConfiguracao }}</span>
            </template>
            <template #foot(semConfiguracao)="">
              <span>{{ totalizadorSemConfiguracao }}</span>
            </template>
            <template #foot(total)="">
              <span>{{ totalizador }}</span>
            </template>
          </b-table>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<style lang="scss">
.tabela-configuracao {
  th {
    vertical-align: top;
    text-transform: unset !important;
    font-size: 0.857rem;
    letter-spacing: 0.5px;
  }
}
.circle {
  height: 15px;
  width: 15px;
  border-radius: 50%;
  margin-right: 0.5rem;
}

.legenda-tabela {
  display: flex;
  align-items: center;
}

.opcao-branca {
  border: 1px solid #82868b !important;
}
</style>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faQuestionCircle,
} from '@fortawesome/free-solid-svg-icons'
import api from '@/app-modulo/documento/dashboard-cobranca/shared/services/api'

export default {
  name: 'ConfiguracaoCobrancaTabela',
  components: {
    FontAwesomeIcon,
  },
  data() {
    return {
      faQuestionCircle,
      colunas: [
        { key: 'equipe', label: 'Equipe' },
        { key: 'comConfiguracao', label: 'Com configuração' },
        { key: 'semConfiguracao', label: 'Sem configuração' },
        { key: 'total', label: 'Total' },
      ],
      dados: [],
      carregado: false,
      descricao: 'Nesse índice é detalhado as empresas com e sem configuração de cobrança por equipe. Através desse detalhamento também é possível acompanhar a quantidade de empresas ativas vinculadas a cada equipe.',
    }
  },
  computed: {
    totalizadorComConfiguracao() {
      let total = 0
      for (let index = 0; index < this.dados.length; index += 1) {
        const element = this.dados[index]
        total += parseInt(element.totalConfiguracao, 10)
      }
      return total.toLocaleString('pt-BR')
    },
    totalizadorSemConfiguracao() {
      let total = 0
      for (let index = 0; index < this.dados.length; index += 1) {
        const element = this.dados[index]
        total += parseInt(element.totalSemConfiguracao, 10)
      }
      return total.toLocaleString('pt-BR')
    },
    totalizador() {
      let total = 0
      for (let index = 0; index < this.dados.length; index += 1) {
        const element = this.dados[index]
        total += parseInt(element.total, 10)
      }
      return total.toLocaleString('pt-BR')
    },
  },
  created() {
    this.carregarDados()
  },
  methods: {
    carregarDados() {
      api.getEquipesConfiguracaoCobranca()
        .then(payload => {
          this.dados = payload.data
          this.carregado = true
        })
    },
  },
}
</script>
